export default "__VITE_ASSET__CNxyE_BH__"